import { HorizontalView, VerticalView } from 'src/components/FlexViews';
import styled from 'styled-components';
import { ReactComponent as LeftArrowIcon } from 'src/assets/icons/bonus-game/left-arrow.svg';
import { DailyRewardItem } from './components/RewardItem';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { bonusGameApi } from 'src/api/bonus-game';
import {
  CheckNextRewardsResponseObject,
  GetRewardsHistoryResponseObject,
} from 'src/api/Api';
import { MobileHeader } from '../../components/Header';
import { PageWrapper } from '../../ui/common';
import { useUserContext } from '../../contexts/UserContext';
import Loader from 'src/pages/Education/components/Loader';

const Title = styled.p`
  text-align: center;
  font-family: Public-Sans, sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
`;

const HeaderWrapper = styled(HorizontalView)`
  ${Title} {
    margin: auto;
    position: relative;
    left: -12px;
  }
  margin-bottom: 32px;
`;

const DailyRewardsWrapper = styled(HorizontalView)`
  flex-wrap: wrap;
  gap: 2.051vw;
  justify-content: flex-start;
  margin-top: 20px;

  @media (max-width: 360px) {
    justify-content: center;
    gap: 4vw;
  }
`;

const MultiplierWrapper = styled(HorizontalView)`
  justify-content: space-between;
  padding: 0 12px;
  height: 40px;
  border-radius: 8px;
`;

const MultiplierText = styled.p`
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
`;
const MultiplierX = styled.p`
  font-weight: 500;
  font-size: 11px;
`;
const MultiplicatorInfoText = styled.p`
  font-size: 11px;
  font-weight: 500;
`;

export const DailyRewardsPage = () => {
  const [rewardData, setRewardData] =
    useState<null | CheckNextRewardsResponseObject>(null);
  const [rewardsHistory, setRewardsHistory] =
    useState<null | GetRewardsHistoryResponseObject>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const nextReward = await bonusGameApi.checkNextReward();
        const rewardsHistoryRes = await bonusGameApi.getRewardsHistory();
        setRewardData(nextReward);
        setRewardsHistory(rewardsHistoryRes.result);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (!rewardData || loading) {
    return <Loader />;
  }

  return (
    <PageWrapper>
      <MobileHeader title="Daily Rewards" />
      {rewardData?.multiplicator === '1' ? (
        <MultiplierWrapper
          style={{ backgroundColor: 'rgba(255, 210, 50, 0.15)' }}>
          <HorizontalView style={{ gap: '4px' }}>
            <MultiplierText>Multiplier</MultiplierText>
            <MultiplierX>x1</MultiplierX>
          </HorizontalView>
          <MultiplicatorInfoText style={{ color: '#FFD232' }}>
            Get x2 Coins!
          </MultiplicatorInfoText>
        </MultiplierWrapper>
      ) : (
        <MultiplierWrapper
          style={{ backgroundColor: 'rgba(196, 245, 56, 0.10)' }}>
          <HorizontalView style={{ gap: '4px' }}>
            <MultiplierText>Multiplier</MultiplierText>
            <MultiplierX style={{ color: '#C4F538' }}>x1</MultiplierX>
          </HorizontalView>
          <MultiplicatorInfoText>
            Nice, you are getting max coins!
          </MultiplicatorInfoText>
        </MultiplierWrapper>
      )}
      <DailyRewardsWrapper>
        {rewardsHistory?.usersHistory?.map(rewardItem => (
          <DailyRewardItem
            key={rewardItem.day}
            {...rewardItem}
            isCurrentDay={rewardItem.day === rewardsHistory.currentDay}
          />
        ))}
      </DailyRewardsWrapper>
    </PageWrapper>
  );
};
